import { connect } from 'react-redux';
import TransactionComponent from '../../Components/Transaction';
import { getMerchantDetail } from '../../redux/actions/MerchantActions';
import { withRouter } from 'react-router';

const TransactionContainer = connect(
    (state) => { //map state to props
        return {
            transaction:state.TransactionReducer,
            user:state.authReducer
        };
    },

    (dispatch) => {
        return {
            getMerchantDetail: () => {
                dispatch(getMerchantDetail());
            }
        };

    }
)(TransactionComponent);

export default withRouter(TransactionContainer);